import _ from 'lodash'
import moment from 'moment-timezone'
import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Container, Grid, Image, Segment } from 'semantic-ui-react'
import ReactLoading from 'react-loading'
import all from '../../assets/images/angle-fuchsia.png'
import { tr } from '../../helpers/languages'
import { send } from '../../helpers/requests'

class ParticipantPerformance extends Component {
    constructor (props) {
        super(props)
        this.state = {
            journals: 0,
            totalWearingTime: 0,
            totalTimeInApp: 0,
            educationalContentCompleted: false,
            calibrationStatus: {
                sad: '',
                angry: '',
                happy: '',
                calm: ''
            },
            sessionsCompleted: 0,
            exercises: {
                completed: 0,
                assigned: 0,
                additional: 0
            },
            module: undefined,
            loading: false,
            patientid: null
        }
        this._isMounted = false
        autoBind(this)
    }

    componentDidMount () {
        this._isMounted = true
        if (this.props.userTokens.accessToken.token) {
            // Fetch the modules.
            // this.fetchModules()
            this.setModules()
        }
    }

    componentWillReceiveProps (nextProps) {
        if (nextProps.userTokens.accessToken.token !== this.props.userTokens.accessToken.token) {
            // Fetch the modules.
            // this.fetchModules()
            this.setModules()
        }
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setModules() {
        this.setState({
                patientid: this.props.match.params.id,
                loading: true
            })
        const data = this.props.participant_details[this.props.match.params.id]
        const now = moment()
            .tz(this.props.timezone)
            .valueOf()
        let module = _.head(data.modules.filter((m) => {
            return parseInt(m.start, 10) <= now && parseInt(m.end, 10) >= now
        })
            .map((m) => { return m.id }))
        // Check whether this is module 0.
        if (_.isEmpty(module)) {
            const m = _.head(data.modules)
            if (!m.start) {
                module = '0'
            }
        }
        this._isMounted && this.setState({
            module,
            journals: 0,
            totalWearingTime: 0,
            totalTimeInApp: 0,
            educationalContentCompleted: false,
            exercises: {
                completed: 0,
                assigned: 0,
                additional: 0
            },
            calibrationStatus: data.calibration,
            sessionsCompleted: data.sessions_completed
        }, () => {
            if (this.state.module) {
                // Count the journals.
                this.countJournals()
                // Count the exercises.
                this.countExercises()
                // Count total wearing time hours
                this.countTotalWearingTime()
                // Count total time in app minutes
                // Commented due to issues with the feature. Needs re-work
                //this.countTotalTimeInApp()
                this.isEducationalContentCompleted()
                this.setState({
                    loading: false
                })
            }
        })
    }

    // Fetches the participant's modules.
    fetchModules () {
        // eslint-disable-next-line no-console
        if (this.state.patientid !== this.props.match.params.id) {
            this.setState({
                patientid: this.props.match.params.id,
                loading: true
            })
            console.log('Fetch modules.')
            return send({
                method: 'GET',
                tokens: this.props.userTokens,
                url: `/patients/${this.props.match.params.id}`
            })
                .then((response) => {
                    // eslint-disable-next-line no-console
                    console.log('Fetch modules.')
                    const data = response.data
                    const now = moment()
                        .tz(this.props.timezone)
                        .valueOf()
                    let module = _.head(data.modules.filter((m) => {
                        return parseInt(m.start, 10) <= now && parseInt(m.end, 10) >= now
                    })
                        .map((m) => { return m.id }))
                    // Check whether this is module 0.
                    if (_.isEmpty(module)) {
                        const m = _.head(data.modules)
                        if (!m.start) {
                            module = '0'
                        }
                    }
                    this._isMounted && this.setState({
                        module,
                        journals: 0,
                        totalWearingTime: 0,
                        totalTimeInApp: 0,
                        educationalContentCompleted: false,
                        exercises: {
                            completed: 0,
                            assigned: 0,
                            additional: 0
                        },
                        calibrationStatus: data.calibration,
                        sessionsCompleted: data.sessions_completed
                    }, () => {
                        if (this.state.module) {
                            // Count the journals.
                            this.countJournals()
                            // Count the exercises.
                            this.countExercises()
                            // Count total wearing time hours
                            this.countTotalWearingTime()
                            // Count total time in app minutes
                            // Commented due to issues with the feature. Needs re-work
                            //this.countTotalTimeInApp()
                            this.isEducationalContentCompleted()
                            this.setState({
                                loading: false
                            })
                        }
                    })
                })
                .catch((error) => {
                    // Failed to fetch modules.
                    // eslint-disable-next-line no-console
                    console.error('Failed to fetch modules.', error)
                    // Hide the error.
                })
        }
    }

    // Counts the participant's journals in the current module.
    countJournals () {
        // eslint-disable-next-line no-console
        console.log('Count journals.')
        send({
            method: 'GET',
            tokens: this.props.userTokens,
            url: `/patients/${this.props.match.params.id}/journals?module_id=${this.state.module}`
        })
            .then((response) => {
                // eslint-disable-next-line no-console
                console.log('Counted journals.')
                this._isMounted && this.setState({ journals: response.data.length })
            })
            .catch((error) => {
                // Failed to count journals.
                // eslint-disable-next-line no-console
                console.error('Failed to count journals.', error)
                // Hide the error.
            })
    }

    // Counts the participant's total wearing time hours in the current module.
    countTotalWearingTime () {
        // eslint-disable-next-line no-console
        console.log('Count total wearing time hours.')
        send({
            method: 'GET',
            tokens: this.props.userTokens,
            url: `/patients/${this.props.match.params.id}/signaltime/${this.state.module}`
        })
            .then((response) => {
                // eslint-disable-next-line no-console
                this._isMounted && this.setState({ totalWearingTime: response.data.total })
            })
            .catch((error) => {
                // Failed to count journals.
                // eslint-disable-next-line no-console
                console.error('sendMetricFailed: ', error)
                // Hide the error.
            })
    }

    // Counts the participant's total time in app hours in the current module.
    countTotalTimeInApp () {
        // eslint-disable-next-line no-console
        console.log('Count total time in app hours.')
        send({
            method: 'GET',
            tokens: this.props.userTokens,
            url: `/patients/${this.props.match.params.id}/timeinapp/${this.state.module}`
        })
            .then((response) => {
                // eslint-disable-next-line no-console
                this._isMounted && this.setState({ totalTimeInApp: response.data.total })
            })
            .catch((error) => {
                // Failed to count journals.
                // eslint-disable-next-line no-console
                console.error('sendMetricFailed: ', error)
                // Hide the error.
            })
    }

     // Counts the participant's total time in app hours in the current module.
     isEducationalContentCompleted () {
        // eslint-disable-next-line no-console
        console.log('Check the completion status of educational content.')
        send({
            method: 'GET',
            tokens: this.props.userTokens,
            url: `/patients/${this.props.match.params.id}/educational-content/${this.state.module}`
        })
            .then((response) => {
                // eslint-disable-next-line no-console
                console.log('Fetched educational content.')
                this._isMounted && this.setState({
                    educationalContentCompleted: response.data.isCompleted
                })
            })
            .catch((error) => {
                // Failed to fetch eductional content.
                // eslint-disable-next-line no-console
                console.error('Failed to fetch eductional content completion status.', error)
                // Hide the error.
                this.setState({ educationalContentCompleted: false })
            })
    }

    // Counts the participant's exercises in the current module.
    countExercises () {
        // There are no exercises for module 0.
        if (this.state.module === '0') {
            return
        }
        // eslint-disable-next-line no-console
        console.log('Count exercises.')
        send({
            method: 'GET',
            tokens: this.props.userTokens,
            url: `/patients/${this.props.match.params.id}/exercises/${this.state.module}`
        })
            .then((response) => {
                // eslint-disable-next-line no-console
                console.log('Counted exercises.')
                const data = response.data.filter((e) => { return e.id && e.status && e.title && e.type })
                const assigned = data.filter((e) => {
                    return e.type === 'assigned'
                }).length
                const completed = data.filter((e) => {
                    return e.type === 'assigned' && (e.status === 'target_completed' || e.status === 'plain_counter')
                }).length
                const additional = data.filter((e) => {
                    return e.type === 'default' && (e.status === 'target_completed' || e.status === 'plain_counter')
                }).length
                this._isMounted && this.setState({ exercises: { assigned, completed, additional } })
            })
            .catch((error) => {
                // Failed to count exercises.
                // eslint-disable-next-line no-console
                console.error('Failed to count exercises.', error)
                // Hide the error.
            })
    }

    render () {
        return (
            <Container className='participant-performance'>
                {this.state.loading ? 
                    <div className='performance-loader'>
                        <ReactLoading type='spin' color='#444'/>
                    </div> :
                    <Grid>
                        {!this.props.participant.is_relief ?
                            <React.Fragment>
                                <Grid.Row columns={2}>
                                    <Grid.Column>
                                        <Segment className='performance'>
                                            <Segment className='performance-title'>{tr('JOURNALS')}</Segment>
                                            <Segment className='performance-details'>
                                                {tr('JOURNALS_COMPLETE', <b>{this.state.journals}</b>,
                                                    tr('PUBLISHED'))}
                                            </Segment>
                                            <Segment
                                                className='performance-see-all'
                                                onClick={(_e) => { this.props.onChangeSubsection('journals') }}
                                            >
                                                {tr('SEE_ALL')}
                                                <Image src={all}/>
                                            </Segment>
                                        </Segment>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Segment className='performance'>
                                            <Segment className='performance-title'>{tr('EXERCISES')}</Segment>
                                            {
                                                this.state.exercises.assigned === 0 && this.state.exercises.additional > 0 ? (
                                                    <Segment className='performance-details'>
                                                        {tr('EXERCISES_COMPLETE_2', <b>{this.state.exercises.additional}</b>,
                                                            tr('EXERCISES_LOWER') + ' ' + tr('COMPLETED_LOWER'))}
                                                    </Segment>
                                                ) : (
                                                    <Segment className='performance-details'>
                                                        {tr('EXERCISES_COMPLETE', <b>{this.state.exercises.completed}</b>,
                                                            <b>{tr('OUT_OF')}</b>,
                                                            <b>{this.state.exercises.assigned}</b>,
                                                            tr('EXERCISES_LOWER') + ' ' + tr('COMPLETED_LOWER'))}
                                                    </Segment>
                                                )
                                            }
                                            {
                                                this.state.exercises.additional > 0 && this.state.exercises.assigned > 0 && (
                                                    <Segment className='performance-more-details'>
                                                        {this.state.exercises.additional} {tr('ADDITIONAL')} {tr('EXERCISES')} {tr('COMPLETED')}
                                                    </Segment>
                                                )
                                            }
                                            <Segment
                                                className='performance-see-all'
                                                onClick={(_e) => { this.props.onChangeSubsection('exercises') }}
                                            >
                                                {tr('SEE_ALL')}
                                                <Image src={all}/>
                                            </Segment>
                                        </Segment>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row columns={2}>
                                    <Grid.Column>
                                        <Segment className='performance'>
                                            <Segment className='performance-title'>{tr('EDUCATIONAL_MATERIAL')}</Segment>
                                            <Segment className='performance-details'>
                                                {this.state.educationalContentCompleted ? 
                                                    <b>{tr('EDUCATIONAL_MATERIAL_COMPLETED')}</b> : 
                                                    <b>{tr('EDUCATIONAL_MATERIAL_NOT_COMPLETED')}</b>} {tr('THIS_WEEK')}
                                            </Segment>
                                            <Segment
                                                className='performance-see-all'
                                                onClick={(_e) => { this.props.onChangeSubsection('educational_content') }}
                                            >
                                                {tr('SEE_ALL')}
                                                <Image src={all}/>
                                            </Segment>
                                        </Segment>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Segment className='performance'>
                                            <Segment className='performance-title'>{tr('SENSOR_WEARING_TIME')}</Segment>
                                            <Segment className='performance-details'>
                                                {tr('HOURS_WEARING_TIME', <b>{Math.round(this.state.totalWearingTime)}</b>)}
                                            </Segment>
                                            <Segment
                                                className='performance-see-all'
                                                onClick={(_e) => { this.props.onChangeSubsection('wearing_time') }}
                                            >
                                                {tr('SEE_ALL')}
                                                <Image src={all}/>
                                            </Segment>

                                        </Segment>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row columns={2}>
                                    {/* <Grid.Column>
                                        <Segment className='performance'>
                                            <Segment className='performance-title'>{tr('SENSOR_TIME_IN_APP')}</Segment>
                                            <Segment className='performance-details'>
                                                {tr('MINUTES_TIME_IN_APP', <b>{Math.round(this.state.totalTimeInApp)}</b>)}
                                            </Segment>
                                            <Segment
                                                className='performance-see-all'
                                                onClick={(_e) => { this.props.onChangeSubsection('time_in_app') }}
                                            >
                                                {tr('SEE_ALL')}
                                                <Image src={all}/>
                                            </Segment>
                                        </Segment>
                                    </Grid.Column> */}
                                    <Grid.Column>
                                        <Segment className='performance'>
                                            <Segment className='performance-title'>{tr('CALIBRATION')}</Segment>
                                            <Segment className='performance-calibration-details'>
                                                <b>{tr('ANGRY') + ':'} </b> {this.state.calibrationStatus.angry ? this.state.calibrationStatus.angry : tr('NOT_STARTED')}
                                            </Segment>
                                            <Segment className='performance-calibration-details'>
                                                <b>{tr('HAPPY') + ':'} </b> {this.state.calibrationStatus.happy ? this.state.calibrationStatus.happy : tr('NOT_STARTED')}
                                            </Segment>
                                            <Segment className='performance-calibration-details'>
                                                <b>{tr('SAD') + ':'} </b> {this.state.calibrationStatus.sad ? this.state.calibrationStatus.sad : tr('NOT_STARTED')}
                                            </Segment>
                                            <Segment className='performance-calibration-details'>
                                                <b>{tr('CALM') + ':'} </b> {this.state.calibrationStatus.calm ? this.state.calibrationStatus.calm : tr('NOT_STARTED')}
                                            </Segment>
                                        </Segment>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row columns={2}>
                                    <Grid.Column>
                                        <Segment className='performance'>
                                            <Segment className='performance-title'>{tr('SESSIONS')} {tr('COMPLETED')}</Segment>
                                            <Segment className='performance-details'>
                                                <b>{this.state.sessionsCompleted}</b> {this.state.sessionsCompleted === 1 ? tr('SESSION') : tr('SESSIONS')} {tr('COMPLETED_LOWER')}
                                            </Segment>
                                        </Segment>
                                    </Grid.Column>
                                </Grid.Row>
                            </React.Fragment> :
                            <React.Fragment>
                                <Grid.Row columns={2}>
                                    <Grid.Column>
                                        <Segment className='performance'>
                                            <Segment className='performance-title'>{tr('JOURNALS')}</Segment>
                                            <Segment className='performance-details'>
                                                {tr('JOURNALS_COMPLETE', <b>{this.state.journals}</b>,
                                                    tr('PUBLISHED'))}
                                            </Segment>
                                            <Segment
                                                className='performance-see-all'
                                                onClick={(_e) => { this.props.onChangeSubsection('journals') }}
                                            >
                                                {tr('SEE_ALL')}
                                                <Image src={all}/>
                                            </Segment>
                                        </Segment>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Segment className='performance'>
                                            <Segment className='performance-title'>{tr('EXERCISES')}</Segment>
                                            {
                                                this.state.exercises.assigned === 0 && this.state.exercises.additional > 0 ? (
                                                    <Segment className='performance-details'>
                                                        {tr('EXERCISES_COMPLETE_2', <b>{this.state.exercises.additional}</b>,
                                                            tr('EXERCISES_LOWER') + ' ' + tr('COMPLETED_LOWER'))}
                                                    </Segment>
                                                ) : (
                                                    <Segment className='performance-details'>
                                                        {tr('EXERCISES_COMPLETE', <b>{this.state.exercises.completed}</b>,
                                                            <b>{tr('OUT_OF')}</b>,
                                                            <b>{this.state.exercises.assigned}</b>,
                                                            tr('EXERCISES_LOWER') + ' ' + tr('COMPLETED_LOWER'))}
                                                    </Segment>
                                                )
                                            }
                                            {
                                                this.state.exercises.additional > 0 && this.state.exercises.assigned > 0 && (
                                                    <Segment className='performance-more-details'>
                                                        {this.state.exercises.additional} {tr('ADDITIONAL')} {tr('EXERCISES')} {tr('COMPLETED')}
                                                    </Segment>
                                                )
                                            }
                                            <Segment
                                                className='performance-see-all'
                                                onClick={(_e) => { this.props.onChangeSubsection('exercises') }}
                                            >
                                                {tr('SEE_ALL')}
                                                <Image src={all}/>
                                            </Segment>
                                        </Segment>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row columns={2}>
                                    <Grid.Column>
                                        <Segment className='performance'>
                                            <Segment className='performance-title'>{tr('EDUCATIONAL_MATERIAL')}</Segment>
                                            <Segment className='performance-details'>
                                                {this.state.educationalContentCompleted ? 
                                                    <b>{tr('EDUCATIONAL_MATERIAL_COMPLETED')}</b> : 
                                                    <b>{tr('EDUCATIONAL_MATERIAL_NOT_COMPLETED')}</b>} {tr('THIS_WEEK')}
                                            </Segment>
                                            <Segment
                                                className='performance-see-all'
                                                onClick={(_e) => { this.props.onChangeSubsection('educational_content') }}
                                            >
                                                {tr('SEE_ALL')}
                                                <Image src={all}/>
                                            </Segment>
                                        </Segment>
                                    </Grid.Column>
                                    {/* <Grid.Column>
                                        <Segment className='performance'>
                                            <Segment className='performance-title'>{tr('SENSOR_TIME_IN_APP')}</Segment>
                                            <Segment className='performance-details'>
                                                {tr('MINUTES_TIME_IN_APP', <b>{Math.round(this.state.totalTimeInApp)}</b>)}
                                            </Segment>
                                            <Segment
                                                className='performance-see-all'
                                                onClick={(_e) => { this.props.onChangeSubsection('time_in_app') }}
                                            >
                                                {tr('SEE_ALL')}
                                                <Image src={all}/>
                                            </Segment>
                                        </Segment>
                                    </Grid.Column> */}
                                </Grid.Row>
                                <Grid.Row columns={2}>
                                    <Grid.Column>
                                        <Segment className='performance'>
                                            <Segment className='performance-title'>{tr('SESSIONS')} {tr('COMPLETED')}</Segment>
                                            <Segment className='performance-details'>
                                                <b>{this.state.sessionsCompleted}</b> {this.state.sessionsCompleted === 1 ? tr('SESSION') : tr('SESSIONS')} {tr('COMPLETED_LOWER')}
                                            </Segment>
                                        </Segment>
                                    </Grid.Column>
                                </Grid.Row>
                            </React.Fragment>
                        }
                    </Grid>
                }
            </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        language: state.settings.language,
        timezone: state.settings.timezone,
        userTokens: state.users.userTokens,
        participant:  state.participants.participant,
        participant_details: state.participants.participant_details
    }
}

const mapDispatchToProps = (_dispatch) => {
    return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ParticipantPerformance))



// WEBPACK FOOTER //
// ./src/components/participant-performance/index.js